import React from "react"
import moment from "moment"
import { Empty } from "antd"
import styled from "styled-components"
import { COLORS, formatPoints } from "./format"

const HEIGHT = 200
const WIDTH = 900

// Долг по дням и пунктиром — прогноз до даты полного погашения.
export function DebtChart({ rows = [], forecastDate }) {
  if (rows.length === 0) {
    return <Empty description="Пока нет данных о долгах" />
  }

  const last = rows[rows.length - 1]
  const forecastDays = forecastDate ? Math.max(moment(forecastDate).diff(moment(last.date), "days"), 0) : 0
  const totalDays = rows.length - 1 + forecastDays
  const maxDebt = Math.max(1, ...rows.map((row) => row.debt))
  const x = (index) => 10 + (index / Math.max(totalDays, 1)) * (WIDTH - 20)
  const y = (debt) => 10 + (1 - debt / maxDebt) * (HEIGHT - 30)
  const points = rows.map((row, index) => `${x(index)},${y(row.debt)}`).join(" ")

  return (
    <ChartWrapper>
      <svg width={WIDTH} height={HEIGHT} role="img" aria-label="Долг по дням">
        <line x1={0} x2={WIDTH} y1={y(0)} y2={y(0)} stroke="#d9d9d9" />
        <polyline points={points} fill="none" stroke={COLORS.debt} strokeWidth={2} />
        {forecastDays > 0 && (
          <line
            x1={x(rows.length - 1)}
            y1={y(last.debt)}
            x2={x(totalDays)}
            y2={y(0)}
            stroke={COLORS.forecast}
            strokeDasharray="6 4"
            strokeWidth={2}
          />
        )}
        <text x={10} y={HEIGHT - 4} fontSize={11} fill="#8c8c8c">{rows[0].date}</text>
        <text x={x(rows.length - 1)} y={HEIGHT - 4} fontSize={11} fill="#8c8c8c" textAnchor="middle">
          {last.date}
        </text>
        {forecastDays > 0 && (
          <text x={WIDTH - 10} y={HEIGHT - 4} fontSize={11} fill={COLORS.forecast} textAnchor="end">
            {forecastDate}
          </text>
        )}
        <text x={14} y={20} fontSize={11} fill="#8c8c8c">{formatPoints(maxDebt)}</text>
      </svg>
    </ChartWrapper>
  )
}

const ChartWrapper = styled.div`
  overflow-x: auto;
  margin-bottom: 16px;
`
